import React from 'react';
import loader from '@img/loader.svg';
import './style.scss';

const Loader = () => (
  <div className='loader'>
    <img width={100} height={100} src={loader} alt='Loading...' />
  </div>
);

export default Loader;
